export default {
  201: 'El horario se ha creado con éxito.',
};
